// extracted by mini-css-extract-plugin
export default {"notifier":"NotificationContext_notifier__yfkbQ","notification":"NotificationContext_notification__eD-QM"};